/**
 * ATAR subjects a teacher can add to their teachable subjects once they teach Year 11 or 12.
 *
 * These are real SubjectPortal children, not profile-only labels, so they match the course
 * groups that already use them: Chemistry / Physics / Biology are the existing children of
 * Science, and the three maths courses were added under Math on 2026-10-02. Matching is by id,
 * so names can change freely.
 */
export const ATAR_SUBJECTS = [
  { id: '1a45b1fc-1889-4aaf-8232-ab0b92204908', label: 'ATAR-Chemistry' },
  { id: '5d08d6eb-f75f-414d-a0b7-c19eb2a7a468', label: 'ATAR-Physics' },
  { id: '4b5e8ccf-4a9c-4581-bd0d-aa49a09f9fc2', label: 'ATAR-Application' },
  { id: '567e7e44-4e5b-4092-9cba-151caa94257c', label: 'ATAR-Method' },
  { id: 'aff4eb48-895e-48ef-834f-c68b70090938', label: 'ATAR-Specialist' },
  { id: '698daed5-6c11-4872-ac7a-71ae94b815bf', label: 'ATAR-Biology' }
];

const ATAR_SUBJECT_IDS = new Set(ATAR_SUBJECTS.map(s => s.id));
const ATAR_YEARS = [11, 12];

export const teachesAtarYears = (grades) =>
  (grades || []).some(g => ATAR_YEARS.includes(Number(g)));

/** Drop the ATAR subjects unless the grades still include Year 11 or 12. */
export const keepAtarSubjectsForGrades = (subjectIds, grades) =>
  (teachesAtarYears(grades)
    ? (subjectIds || [])
    : (subjectIds || []).filter(id => !ATAR_SUBJECT_IDS.has(id)));

export const atarSubjectLabel = (subjectId) =>
  ATAR_SUBJECTS.find(s => s.id === subjectId)?.label || null;
